/**
 * This file is auto-generated from useDateInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const showCalendar: Translation = lang => {
    switch (lang) {
        case 'pl':
            return 'Pokaż kalendarz';
        case 'en':
            return 'Show calendar';
        case 'de':
            return 'Kalender anzeigen';
    }
};
